import { render, staticRenderFns } from "./SlideListParent.vue?vue&type=template&id=3755f0ca&scoped=true&"
import script from "./SlideListParent.vue?vue&type=script&lang=js&"
export * from "./SlideListParent.vue?vue&type=script&lang=js&"
import style0 from "./SlideListParent.vue?vue&type=style&index=0&id=3755f0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3755f0ca",
  null
  
)

export default component.exports